import {Controller} from "@hotwired/stimulus"

let select2Loaded = false

export default class Select2Controller extends Controller {
    static targets = ["selectBackskin", 'selectAnalytics']

    selected = []

	async connect() {
		await this.loadSelect2()
		this.initSelect2()
	}

	async loadSelect2() {
		if (select2Loaded) return

		const module = await import("select2")
		const select2 = module.default || module

		select2($)
		select2Loaded = true
	}

    initSelect2() {
        const $element = $(this.element);
        const dropdownOptions = {
            placeholder: this.hasSelectBackskinTarget ? "Select" : "Search Interest",
            dropdownParent: $element.parent()
        };
        if (this.element.dataset.closeOnSelect === "false") {
            dropdownOptions.closeOnSelect = false;
        }
        $element.select2(dropdownOptions)
            .on('select2:open', (e) => {
                const evt = "scroll.select2";
                $(e.target).parents().off(evt);
                $(globalThis).off(evt);
                const modalBody = $element.closest('.modal-body');
                if (modalBody.length) {
                    modalBody.data('original-overflow', modalBody.css('overflow-y'));
                    modalBody.css('overflow-y', 'hidden');
                }
                if (this.element.dataset.filterRemoved === 'true'){
                    this.searchDisabled()
                }
                setTimeout(() => {
                    const searchInput = document.querySelector('.select2-container--open .select2-search__field');
                    if (searchInput) searchInput.blur();
                }, 0);
            })
            .on('select2:close', (e) => {
                const modalBody = $element.closest('.modal-body');
                if (this.element.dataset.filterRemoved === 'true'){
                    this.searchDisabled()
                }
                if (modalBody.length) {
                    const originalOverflow = modalBody.data('original-overflow') || 'auto';
                    modalBody.css('overflow', originalOverflow);
                }
            })
						.on('select2:select', (e) => {
							if (this.hasSelectAnalyticsTarget) {
								this.handleSubmitSelection(e)
								return;
							}
							if (this.element.dataset.analyticsChart === "true") {
								this.handleUpdateChart();
								return;
							}
							if (!this.hasSelectBackskinTarget) {
								this.handleSelect(e);
								this.setPlaceHolder();
							}
						})
						.on('select2:unselect', (e) => {
							if (this.hasSelectAnalyticsTarget) {
								this.handleSubmitSelection(e)
								return;
							}
							if (this.element.dataset.analyticsChart === "true") {
								this.handleUpdateChart();
								return;
							}
							if (!this.hasSelectBackskinTarget) {
								this.handleSelect(e);
								this.setPlaceHolder();
							}
						});
    }

		handleSubmitSelection(e) {
			const value = e.target.value
			const url = new URL(this.element.dataset.url, window.location.origin)
			url.searchParams.set("range", value)

			fetch(url, {
				method: 'get',
				headers: {
					'Accept': "text/vnd.turbo-stream.html"
				}
			})
			.then(r => r.text())
			.then(html => Turbo.renderStreamMessage(html));
		}

		handleUpdateChart() {
			const status = document.getElementById("analytics-bar-status")?.value
  		const year = document.getElementById("analytics-bar-details")?.value
			const url = new URL(this.element.dataset.url, window.location.origin)

			url.searchParams.set("year", year)
			url.searchParams.set("status", status)

			fetch(url, {
				method: 'get',
				headers: {
					'Accept': "text/vnd.turbo-stream.html"
				}
			})
			.then(r => r.text())
			.then(html => Turbo.renderStreamMessage(html));
		}

		handleSelect(e) {
			const data = e.params.data;

			const id = data.id;
			const name = data.text;
			const image = this.element.dataset.image;

			const $container = $(this.element)
				.closest(".analytics-page")
				.find(".interest-value");

			if (this.selected.includes(id)) {

				this.selected = this.selected.filter(val => val != id);

				$container.find(`.interest-name-value[data-value="${id}"]`)
					.closest('.remove-interest')
					.remove();

				let values = $(this.element).val() || [];
				values = values.filter(val => val != id);
				$(this.element).val(values).trigger('change.select2');

			} else {

				this.selected.push(id);

				const $el = $(`
					<div class="remove-interest position-relative d-flex align-items-center justify-content-center px-5 py-1">
						<img class="img img-fluid position-absolute" src="${image}">
						<span class="text-white-paint text-black interest-name-value text-center d-inline-block p-font-bold fs-16 position-relative" data-value="${id}">
							${name}
						</span>
						<button class="position-relative btn p-0 fs-20 fw-bold scale-hover" data-id="${id}">
							<i class="ri-close-fill"></i>
						</button>
					</div>
				`);

				$el.find('button').on('click', (event) => {
					this.removeData(event);
				});

				$container.append($el);
			}

			if ($container.children().length) {
				$container.removeClass('d-none').addClass('d-flex');
			} else {
				$container.addClass('d-none').removeClass('d-flex');
			}

			this.fetchData();
		}

		fetchData() {
			fetch('/connects?interest_name=' + this.selected.join(','), {
				method: 'get',
				headers: {
					'Accept': "text/vnd.turbo-stream.html",
					"X-CSRF-Token": document.getElementsByName("csrf-token")[0].content,
					'Content-Type': 'application/json'
				}
			})
			.then(r => r.text())
			.then(html => Turbo.renderStreamMessage(html));
		}

		removeData(e) {
			const id = e.currentTarget.dataset.id;

			const $container = $(this.element)
				.closest(".analytics-page")
				.find(".interest-value");

			$container.find(`.interest-name-value[data-value="${id}"]`)
				.closest('.remove-interest')
				.remove();

			this.selected = this.selected.filter(val => val != id);

			let values = $(this.element).val() || [];
			values = values.filter(val => val != id);

			$(this.element).val(values).trigger('change.select2');
			this.setPlaceHolder();
			this.fetchData();
		}

		setPlaceHolder() {
			$('#select2-interests-container').html('');
			$('#select2-interests-container').parent()?.find('textarea')?.attr('placeholder', 'Select Interest');
			if ($('#select2-interests-container').parent().find('textarea')[0]){
				$('#select2-interests-container').parent().find('textarea')[0].style.width = '100%'
			}
		}

    searchDisabled(){
        const searchTextarea = document.querySelector('.select2-search__field');
        searchTextarea.setAttribute('disabled', 'disabled');
    }

}
